var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6901 1.33331V3.99998M5.35677 1.33331V3.99998M2.02344 6.66665H14.0234M3.35677 2.66665H12.6901C13.4265 2.66665 14.0234 3.2636 14.0234 3.99998V13.3333C14.0234 14.0697 13.4265 14.6666 12.6901 14.6666H3.35677C2.62039 14.6666 2.02344 14.0697 2.02344 13.3333V3.99998C2.02344 3.2636 2.62039 2.66665 3.35677 2.66665Z",
    stroke: "#101828",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a2d6bdc5d6299beb0d2b9c0177621d64.svg";
export { ForwardRef as ReactComponent };